import React from 'react'

const RedeemOfferTermAndCondition = ({ description }) => {

    return (
        <div className='mt-3'>
            <div className="row">
                <div className="col-md-12 p-3 mb-3">

                    <h3 style={{ fontWeight: "normal", color: "#404553" }}>Terms & Conditions</h3>

                    {/* <hr className='divider' /> */}
                    <div style={{ background: "#ccc", width: "100%", height: '1px', marginTop: "5px", marginBottom: "10px" }} />

                    <div
                        className="offer_description_content"
                        dangerouslySetInnerHTML={{ __html: description?.business_redeem_term_and_condition }}
                    />
                </div>
            </div>
        </div>
    )
}

export default RedeemOfferTermAndCondition;
